import {useSearchParams} from "react-router-dom";

/**
 * Checks if any customer-related data is found in the query parameters and saves them to the store.
 */
export const useJwtTokenParameters = () => {
    const [searchParams] = useSearchParams()
    const token = searchParams.get("jwt")

    const jwtTokenParams = () => {
        if (!token) {
            return {}
        }
        return {
            jwt: token
        }
    }

    return {jwtTokenParams}
}
